import axios from "axios";
import { getToken } from "../../Utlis/UpdateUserState";

const getAdminProfile = async (config = {}) => {
  try {
    const token = getToken();

    const res = await axios.get(
      `${process.env.REACT_APP_BACKEND_URL}admin/profile/`,
      {
        ...config,
        headers: { Authorization: `Bearer ${token}` },
      },
    );

    return res;
  } catch (error) {
    console.error("Admin profile fetch error:", error);
    throw error;
  }
};

const getRoles = async () => {
  try {
    const token = getToken();

    const res = await axios.get(
      `${process.env.REACT_APP_BACKEND_URL}admin/roles/lookup`,
      {
        headers: { Authorization: `Bearer ${token}` },
      },
    );

    return res;
  } catch (error) {
    console.error("Roles fetch error:", error);
    throw error;
  }
};

const updatePageAccess = async (id, pageAccess) => {
  try {
    const token = getToken();

    const res = await axios.put(
      `${process.env.REACT_APP_BACKEND_URL}admin/profile/page-access/?id=${id}`,
      { page_access: pageAccess },
      {
        headers: { Authorization: `Bearer ${token}` },
      },
    );

    return res;
  } catch (error) {
    console.error("Page access update error:", error);
    throw error;
  }
};

const updateAdminProfile = async (id, data) => {
  try {
    const token = getToken();

    const formData = new FormData();
    Object.entries(data).forEach(([key, value]) => {
      if (value !== undefined && value !== null) {
        formData.append(key, value);
      }
    });

    const res = await axios.patch(
      `${process.env.REACT_APP_BACKEND_URL}admin/profile/?id=${id}`,
      formData,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data",
        },
      },
    );

    return res;
  } catch (error) {
    console.error("Admin profile update error:", error);
    throw error;
  }
};

const updateAdminAvatar = async (id, avatarFile) => {
  try {
    const token = getToken();

    const formData = new FormData();
    formData.append("avatar", avatarFile);

    const res = await axios.postForm(
      `${process.env.REACT_APP_BACKEND_URL}admin/users/avatar/?id=${id}`,
      formData,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data",
        },
      },
    );

    return res;
  } catch (error) {
    console.error("Admin avatar update error:", error);
    throw error;
  }
};

const changeAdminPassword = async (data) => {
  try {
    const token = getToken();

    const res = await axios.post(
      `${process.env.REACT_APP_BACKEND_URL}admin/profile/change-password/`,
      data,
      {
        headers: { Authorization: `Bearer ${token}` },
      },
    );

    return res;
  } catch (error) {
    console.error("Password change error:", error);
    throw error;
  }
};

export {
  getAdminProfile,
  getRoles,
  updatePageAccess,
  updateAdminProfile,
  updateAdminAvatar,
  changeAdminPassword,
};
